import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";
import Cookies from "js-cookie";


export const InvoiceListApi = createAsyncThunk(
    "member/invoiceList",
    async (data) => {
        const url = baseUrl + "invoiceList";
        const token = Cookies.get("token");

        try{
            const response = (await axios.post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })).data
            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }
    }
)

export const InvoiceByIdApi = createAsyncThunk(
    "member/invoiceById",
    async(data) => {
        const url = baseUrl + "invoiceById";
        const token = Cookies.get("token");
        try{
            const response = (await axios.post(url, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)



export const insertInvoice = createAsyncThunk(
    "insertInvoice",
    async(data) => {
        const url = baseUrl + "insertinvoice";
        const token = Cookies.get("token");
        try{
            const response = (await axios.post(url, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)

export const getMemberInvoice = createAsyncThunk(
    "getMemberInvoice",
    async(data) => {
        const url = baseUrl + `${data.companyId}/getMemberInvoices`;
        const token = Cookies.get("token");
        try{
            const response = (await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)

export const deleteMemberInvoice = createAsyncThunk(
    "deleteMemberInvoice",
    async(data) => {
        const url = baseUrl + `deleteMemberInvoice`;
        const token = Cookies.get("token");
        try{
            const response = (await axios.post(url, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)

export const updateMemberInvoice = createAsyncThunk(
    "updateMemberInvoice",
    async(data) => {
        const url = baseUrl + `updateMemberInvoice`;
        const token = Cookies.get("token");
        try{
            const response = (await axios.post(url, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)




